import { G } from '@mobily/ts-belt';
import { Box, SxProps } from '@mui/material';
import { FC, JSX } from 'react';
import { TabProps } from 'react-admin';

import { PermissionActionT } from '@Common/types/bo/authorization';
import { BOResourceAll } from '@Common/types/bo_external/resources';

import { FixedButton } from '@sh4res/bo-common/components/FixedButton';
import { Tab } from '@sh4res/bo-common/components/Tab';

export const tabStyles: SxProps = {
  minHeight: '34px',
  justifyContent: 'flex-start',
  textTransform: 'capitalize',
  fontSize: '14.5px',
  fontWeight: '600',
  marginBottom: '4px',
  paddingRight: '25px',
  textAlign: 'left',
  '& svg': {
    width: '20px',
    height: '20px',
  },
};

type CustomTabProps = TabProps & {
  button?: JSX.Element;
  permission?: { resource: BOResourceAll; action: PermissionActionT };
};
export const VerticalTab: FC<CustomTabProps & { 'data-testid'?: string }> = ({
  children,
  button,
  sx,
  permission: _permission,
  'data-testid': dataTestId,
  ...props
}) => {
  const contentStyles: SxProps = {
    height: '100%',
    boxSizing: 'border-box',
    overflow: 'visible',
  };

  return (
    <Tab sx={{ ...tabStyles, ...sx }} iconPosition="start" {...props}>
      <Box sx={contentStyles}>
        <Box sx={{ overflow: 'hidden', height: '100%' }}>{children}</Box>
        {G.isNotNullable(button) && <FixedButton data-testid={dataTestId}>{button}</FixedButton>}
      </Box>
    </Tab>
  );
};
